import { defineStore } from "pinia";
import { ClientType } from "../types/clientsType";
import { ref } from "vue";

export const useClientStore = defineStore(
  "client",
  () => {
    const clientId = ref<number | null>(null);
    const client = ref<ClientType | null>(null);

    function setClient(newClient: ClientType) {
      clientId.value = newClient.companyId;
      client.value = newClient;
    }

    function getClientId() {
      return clientId.value;
    }

    function getClient() {
      return client.value;
    }

    return {
      clientId,
      client,
      setClient,
      getClientId,
      getClient,
    };
  },
  {
    persist: true,
  }
);
